__turbopack_context__.v({
  "actions": "customJewelry-module__xtnegW__actions",
  "consent": "customJewelry-module__xtnegW__consent",
  "error": "customJewelry-module__xtnegW__error",
  "eyebrow": "customJewelry-module__xtnegW__eyebrow",
  "form": "customJewelry-module__xtnegW__form",
  "formIntro": "customJewelry-module__xtnegW__formIntro",
  "formSection": "customJewelry-module__xtnegW__formSection",
  "full": "customJewelry-module__xtnegW__full",
  "hero": "customJewelry-module__xtnegW__hero",
  "heroCopy": "customJewelry-module__xtnegW__heroCopy",
  "note": "customJewelry-module__xtnegW__note",
  "page": "customJewelry-module__xtnegW__page",
  "steps": "customJewelry-module__xtnegW__steps",
  "submitRow": "customJewelry-module__xtnegW__submitRow",
  "success": "customJewelry-module__xtnegW__success",
  "trust": "customJewelry-module__xtnegW__trust",
});
